import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useAppStore } from "@/ts/stores/app";
import Slideout from "@/ts/components/elements/slideout.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import LanguageSwitch from "@/ts/components/elements/language-switch.vue";

interface Props {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    translatedRoutes: { nl?: { relative_url: string; lang: string }; fr?: { relative_url: string; lang: string }; en?: { relative_url: string; lang: string } };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'slideout-navigation',
  props: {
    centerLinks: { type: Array, required: false },
    rightLinks: { type: Array, required: false },
    translatedRoutes: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const breakpoints = useBreakpoints(breakpointsTailwind);
const showNavigation = breakpoints.smaller("lg");

const appStore = useAppStore();

const props = __props;

const lang = computed(() => {
    return document.documentElement.lang;
});

const __returned__ = { breakpoints, showNavigation, appStore, props, lang, Slideout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})